import { render } from "./editRawMaterialProductionProcessModal.vue?vue&type=template&id=63a35121&ts=true"
import script from "./editRawMaterialProductionProcessModal.vue?vue&type=script&lang=ts"
export * from "./editRawMaterialProductionProcessModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__